import React, { useState } from 'react';
import styled from 'styled-components';

import { MAIN_DARK } from '@espacePro/constants/admin-theme';
import { Z_INDEXES } from '@espacePro/constants/z-indexes';
import Close from '@espaceProImages/icon-close-2.inline.svg';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${MAIN_DARK};
  opacity: 0.8;
  z-index: ${Z_INDEXES.OVERLAY};
`;

const Content = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 24px 48px 24px 24px;
  z-index: ${Z_INDEXES.OVERLAY + 1};
`;

const CloseIcon = styled(Close)`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 16px;
  right: 16px;
`;

const BottomSheets = ({ children, button }: { children: JSX.Element, button: JSX.Element }) => {
  const [isOpened, setOpened] = useState(false);
  const toggleOpened = () => setOpened(!isOpened);

  return (
    <div>
      {React.cloneElement(button, {
        onClick: toggleOpened,
      })}
      {isOpened && (
        <>
          <Backdrop onClick={toggleOpened} />
          <Content>
            <CloseIcon onClick={toggleOpened} />
            {children}
          </Content>
        </>
      )}
    </div>
  );
};

export { BottomSheets };
